import { render } from "./SelectedFeature.vue?vue&type=template&id=51721197&scoped=true&ts=true"
import script from "./SelectedFeature.vue?vue&type=script&lang=ts"
export * from "./SelectedFeature.vue?vue&type=script&lang=ts"

import "./SelectedFeature.vue?vue&type=style&index=0&id=51721197&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51721197"]])

export default __exports__